module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask-layer mask"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            发送文书\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form_item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form_right"
  }, [_c('el-input', {
    staticClass: "el_box",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.model.phone),
      callback: function($$v) {
        _vm.$set(_vm.model, "phone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "model.phone"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn mr20",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("发送")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_left mln12"
  }, [_c('p', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("手机号码：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69478932","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/zhiFa/components/send.vue
// module id = +gYW
// module chunks = 4